import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../../application/config/config';
import Fetch from "../../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../../helpers/chooseProfileFilter";


function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id
    }

    const path = '/projects/';
    const paths = {
        endpointSave: config.endpoints.backend + 'projects/save',
        endpointGetById: config.endpoints.backend + 'projects/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetOneProject: config.endpoints.backend + 'projects/getone',
        endpointGetAllUfPortal: config.endpoints.backend + 'ufportal/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleEdit: "Configurações do Portal"
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Foto',
                    uploadPath: '/projects/',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'friendly_url',
                    type: 'text',
                    label: 'URL Amigável',
                    validations: {
                        required: false,
                        verifyFriendlyUrl: true
                    },
                    columnSize: 12
                },
                {
                    name: 'has_siasus_dashboard',
                    type: 'select',
                    label: 'Dashboard - SiaSus',
                    options: [
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'has_sihsus_dashboard',
                    type: 'select',
                    label: 'Dashboard - SihSus',
                    options: [
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'has_samu_dashboard',
                    type: 'select',
                    label: 'Dashboard - SAMU',
                    options: [
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'samu_city_id',
                    type: 'text',
                    label: 'Dashboard - SAMU - Código IBGE do Município',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_uf_portal_id',
                    type: 'select',
                    label: 'UF - Portal',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllUfPortal,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                verifyFriendlyUrl: async (value, options, key, attributes) => {
                    if (attributes.friendly_url) {
                        const verifyData = await Fetch.post(paths.endpointGetOneProject, {
                            filter: {
                                friendly_url: attributes.friendly_url,
                                deleted: '0'
                            }
                        })

                        if (verifyData && verifyData.friendly_url == attributes.friendly_url && verifyData.id != id) {
                            return '^ Já existe um projeto com essa URL.'
                        } else {
                            return ''
                        }
                    } else {
                        return ''
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
